import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import axios from "axios";
import Swal from "sweetalert2";

import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";
import socket from "../tools/socke";

import ModalSancion from "./Modal";
import Sancion from "./Sancion";
import SelectorCantidadSancionRecursa from "./SelectorCantidadSancionRecursa";

import "./Sancionaa.css";

const ObtieneSancionesRecursadas = ({ refresca }) => {
  const Usuario = ObtieneDatosCookies();

  // ============================================================
  // ESTADOS
  // ============================================================

  const [listadoSanciones, setListadoSanciones] = useState([]);
  const [cargando, setCargando] = useState(false);

  const [sancionSeleccionada, setSancionSeleccionada] =
    useState(null);

  const [veoDatosSancion, setVeoDatosSancion] =
    useState(false);

  const [modificarValores, setModificarValores] =
    useState(false);

  const [error, setError] = useState("");

  // ============================================================
  // TOKEN
  // ============================================================

  const obtenerToken = () => {
    const username = process.env.REACT_APP_KEY;
    const password = process.env.REACT_APP_PASS;

    return btoa(`${username}:${password}`);
  };

  // ============================================================
  // OBTENER SANCIONES RECURSADAS
  // ============================================================

  const obtieneSancionesRecursadas = useCallback(async () => {
    if (!Usuario?.id) {
      return;
    }

    try {
      setCargando(true);
      setError("");

      let sede = null;

      // Director EP consulta todas
      if (
        comprueboPermisos(
          Usuario?.funcion,
          "Director EP"
        )
      ) {
        sede = "";
      }

      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/Ncadetes/devuelveSancionesRecursadas",
        {
          sede,
        }
      );

      const sancionesTotales = Array.isArray(response?.data)
        ? response.data
        : [];

      // Director EP ve todas.
      // El resto no resuelve sus propias sanciones.
      const sancionesFiltradas =
        comprueboPermisos(
          Usuario?.funcion,
          "Director EP"
        )
          ? sancionesTotales
          : sancionesTotales.filter(
              (sancion) =>
                Number(sancion?.idUsuarioSanciona) !==
                Number(Usuario?.id)
            );

      setListadoSanciones(sancionesFiltradas);
    } catch (error) {
      console.error(
        "Error obteniendo sanciones recurridas:",
        error
      );

      setListadoSanciones([]);

      setError(
        "No se pudieron obtener las sanciones reclamadas."
      );
    } finally {
      setCargando(false);
    }
  }, [
    Usuario?.id,
    Usuario?.funcion,
  ]);

  // ============================================================
  // CERRAR MODAL
  // ============================================================

  const cerrarModal = () => {
    setVeoDatosSancion(false);
    setSancionSeleccionada(null);
    setModificarValores(false);
  };

  // ============================================================
  // DEJAR SIN EFECTO POR RECURSO
  // ============================================================

  const anulaSancion = async (sancion) => {
    try {
      const confirmacion = await Swal.fire({
        title: "¿Dejar sanción sin efecto?",
        text:
          "Se resolverá favorablemente el recurso y la sanción quedará sin efecto.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText:
          "Sí, dejar sin efecto",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#b42318",
      });

      if (!confirmacion.isConfirmed) {
        return;
      }

      const token = obtenerToken();

      const datos = {
        usuarioResuelveRecurso:
          `${Usuario?.nombre || ""} ${
            Usuario?.apellido || ""
          }`.trim(),

        resuelveRecurso:
          "Sin Efecto",

        cantidadResuelveRecurso: 0,

        fechaResuelveRecurso:
          new Date(),

        estado: "Anulada",
      };

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
        datos,
        {
          headers: {
            Authorization:
              `Basic ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        await Swal.fire({
          title:
            "Recurso resuelto",
          text: `La sanción del cadete DNI ${sancion.cadeteDni} fue dejada sin efecto.`,
          icon: "success",
          confirmButtonText:
            "Aceptar",
        });

        socket.emit(
          "sancionEvent",
          sancion.cadeteDni
        );

        cerrarModal();
        obtieneSancionesRecursadas();

        return;
      }

      Swal.fire({
        title:
          response?.data?.message ||
          "No se pudo resolver",
        text:
          "Compruebe los datos e intente nuevamente.",
        icon: "error",
        confirmButtonText:
          "Aceptar",
      });
    } catch (error) {
      console.error(
        "Error dejando sin efecto sanción recurrida:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          "No se pudo resolver el recurso.",
        icon: "error",
        confirmButtonText:
          "Aceptar",
      });
    }
  };

  // ============================================================
  // CONFIRMAR SANCION LUEGO DEL RECURSO
  // ============================================================

  const confirmarSancion = async (sancion) => {
    try {
      const confirmacion = await Swal.fire({
        title: "Confirmar sanción reclamada",
        text:
          "Se rechazará el recurso y la sanción continuará vigente.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText:
          "Confirmar sanción",
        cancelButtonText:
          "Cancelar",
        confirmButtonColor:
          "#315f64",
      });

      if (!confirmacion.isConfirmed) {
        return;
      }

      const token = obtenerToken();

      const datos = {
        usuarioResuelveRecurso:
          `${Usuario?.nombre || ""} ${
            Usuario?.apellido || ""
          }`.trim(),

        resuelveRecurso:
          "Confirmar",

        cantidadResuelveRecurso:
          sancion?.cantidad,

        fechaResuelveRecurso:
          new Date(),

        estado:
          "Resuelto Reclamada",
      };

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
        datos,
        {
          headers: {
            Authorization:
              `Basic ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        await Swal.fire({
          title:
            "Recurso resuelto",
          text: `La sanción del cadete DNI ${sancion.cadeteDni} fue confirmada.`,
          icon: "success",
          confirmButtonText:
            "Aceptar",
        });

        socket.emit(
          "sancionEvent",
          sancion.cadeteDni
        );

        cerrarModal();
        obtieneSancionesRecursadas();

        return;
      }

      Swal.fire({
        title:
          response?.data?.message ||
          "No se pudo resolver",
        text:
          "Compruebe los datos e intente nuevamente.",
        icon: "error",
        confirmButtonText:
          "Aceptar",
      });
    } catch (error) {
      console.error(
        "Error confirmando sanción recurrida:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          "No se pudo completar la resolución del recurso.",
        icon: "error",
        confirmButtonText:
          "Aceptar",
      });
    }
  };

  // ============================================================
  // SOCKET
  // ============================================================

  useEffect(() => {
    obtieneSancionesRecursadas();

    const handleActualizacion = () => {
      obtieneSancionesRecursadas();
    };

    socket.on(
      "estadoActualizable",
      handleActualizacion
    );

    return () => {
      socket.off(
        "estadoActualizable",
        handleActualizacion
      );
    };
  }, [
    refresca,
    obtieneSancionesRecursadas,
  ]);

  // ============================================================
  // CATEGORIAS
  // ============================================================

  const categorias = useMemo(() => {
    return listadoSanciones.reduce(
      (acc, sancion) => {
        const estado =
          sancion?.estado ||
          "Sin estado";

        if (!acc[estado]) {
          acc[estado] = [];
        }

        acc[estado].push(sancion);

        return acc;
      },
      {}
    );
  }, [listadoSanciones]);

  // ============================================================
  // ABRIR DETALLE
  // ============================================================

  const manejoQueVeo = (sancion) => {
    setSancionSeleccionada(sancion);
    setModificarValores(false);
    setVeoDatosSancion(true);
  };

  // ============================================================
  // HELPERS
  // ============================================================

  const nombreCompleto = (sancion) => {
    const apellido =
      sancion?.cadete
        ?.cadeteApellido || "";

    const nombre =
      sancion?.cadete
        ?.cadeteNombre || "";

    return `${apellido} ${nombre}`.trim();
  };

  const obtenerUbicacion = (
    sancion
  ) => {
    const compania =
      sancion?.cadete?.Seccion
        ?.Compania?.nombre;

    const seccion =
      sancion?.cadete?.Seccion
        ?.nombre;

    return [
      compania,
      seccion,
    ]
      .filter(Boolean)
      .join(" · ");
  };

  const obtenerPromocion = (
    sancion
  ) => {
    return (
      sancion?.cadete
        ?.Promocions?.[0]
        ?.nombre || null
    );
  };

  const formatearFecha = (
    fecha
  ) => {
    if (!fecha) {
      return "-";
    }

    const partes =
      String(fecha).split("-");

    if (partes.length === 3) {
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }

    return fecha;
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      {/* ====================================================== */}
      {/* MODAL RESOLVER RECURSO */}
      {/* ====================================================== */}

      {veoDatosSancion &&
        sancionSeleccionada && (
          <ModalSancion
            isOpen={
              veoDatosSancion
            }
            onClose={cerrarModal}
          >
            <div className="san-v2-modal">

              {/* ============================================ */}
              {/* HEADER */}
              {/* ============================================ */}

              <div className="san-v2-modal-header">

                <span className="san-v2-modal-eyebrow">
                  RECURSO DISCIPLINARIO
                </span>

                <h3>
                  Resolver sanción reclamada
                </h3>

                <p>
                  Revise la actuación original y
                  la presentación efectuada por
                  el cadete antes de adoptar una
                  resolución.
                </p>

              </div>

              {/* ============================================ */}
              {/* CADETE */}
              {/* ============================================ */}

              <div className="san-v2-selected-person">

                <div className="san-v2-avatar">
                  {sancionSeleccionada
                    ?.cadete
                    ?.cadeteApellido
                    ?.charAt(0)
                    ?.toUpperCase() ||
                    "C"}
                </div>

                <div className="san-v2-selected-info">

                  <span>
                    CADETE
                  </span>

                  <strong>
                    {nombreCompleto(
                      sancionSeleccionada
                    ) ||
                      `DNI ${sancionSeleccionada.cadeteDni}`}
                  </strong>

                  <small>
                    DNI{" "}
                    {
                      sancionSeleccionada.cadeteDni
                    }

                    {sancionSeleccionada
                      ?.cantidad
                      ? ` · Sanción: ${sancionSeleccionada.cantidad}`
                      : ""}
                  </small>

                </div>

                <span className="san-v2-section-badge">
                  Reclamada
                </span>

              </div>

              {/* ============================================ */}
              {/* DETALLE */}
              {/* ============================================ */}

              <div className="san-v2-form-container">

                <Sancion
                  sancionPasada={
                    sancionSeleccionada
                  }
                />

                {/* ========================================== */}
                {/* RESOLUCION PERSONALIZADA */}
                {/* ========================================== */}

                <div
                  style={{
                    marginTop:
                      "16px",
                    paddingTop:
                      "16px",
                    borderTop:
                      "1px solid #eaecf0",
                  }}
                >

                  <button
                    type="button"
                    className="san-v2-btn-secondary"
                    onClick={() =>
                      setModificarValores(
                        (prev) => !prev
                      )
                    }
                  >
                    {modificarValores
                      ? "Cancelar resolución"
                      : "Resolver recurso"}
                  </button>

                  {modificarValores && (
                    <div
                      style={{
                        marginTop:
                          "14px",
                        padding:
                          "14px",

                        border:
                          "1px solid #e4e7ec",

                        borderRadius:
                          "12px",

                        background:
                          "#f9fafb",
                      }}
                    >
                      <SelectorCantidadSancionRecursa
                        sancion={
                          sancionSeleccionada
                        }
                        valores={() => {
                          cerrarModal();

                          obtieneSancionesRecursadas();
                        }}
                      />
                    </div>
                  )}

                </div>

                {/* ========================================== */}
                {/* ACCIONES RAPIDAS */}
                {/* ========================================== */}

                <div
                  style={{
                    display: "flex",
                    justifyContent:
                      "flex-end",
                    alignItems:
                      "center",
                    gap: "9px",
                    flexWrap:
                      "wrap",

                    marginTop:
                      "18px",

                    paddingTop:
                      "15px",

                    borderTop:
                      "1px solid #eaecf0",
                  }}
                >

                  <button
                    type="button"
                    className="san-v2-btn-secondary"
                    disabled={
                      modificarValores
                    }
                    onClick={() =>
                      anulaSancion(
                        sancionSeleccionada
                      )
                    }
                    style={{
                      color:
                        "#b42318",
                    }}
                  >
                    Dejar sin efecto
                  </button>

                  <button
                    type="button"
                    className="san-v2-btn-primary"
                    disabled={
                      modificarValores
                    }
                    onClick={() =>
                      confirmarSancion(
                        sancionSeleccionada
                      )
                    }
                  >
                    ✓ Confirmar sanción
                  </button>

                </div>

              </div>

            </div>
          </ModalSancion>
        )}

      {/* ====================================================== */}
      {/* CONTENIDO */}
      {/* ====================================================== */}

      <div style={{ width: "100%" }}>

        {/* ==================================================== */}
        {/* RESUMEN */}
        {/* ==================================================== */}

        <div className="san-v2-summary">

          <div className="san-v2-stat-card">

            <div className="san-v2-stat-icon san-v2-stat-icon-recurso">
              ↺
            </div>

            <div>

              <span>
                Recursos pendientes
              </span>

              <strong>
                {cargando
                  ? "..."
                  : listadoSanciones.length}
              </strong>

              <small>
                Sanciones reclamadas
              </small>

            </div>

          </div>

        </div>

        {/* ==================================================== */}
        {/* ERROR */}
        {/* ==================================================== */}

        {error && (
          <section
            className="san-v2-section"
            style={{
              borderColor:
                "#fecdca",
            }}
          >
            <div
              className="san-v2-section-content"
              style={{
                padding:
                  "14px",

                color:
                  "#b42318",
              }}
            >
              {error}
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* CARGANDO */}
        {/* ==================================================== */}

        {cargando && (
          <section className="san-v2-section">

            <div
              className="san-v2-section-content"
              style={{
                padding:
                  "30px",

                textAlign:
                  "center",

                color:
                  "#667085",
              }}
            >
              Obteniendo sanciones
              reclamadas...
            </div>

          </section>
        )}

        {/* ==================================================== */}
        {/* VACIO */}
        {/* ==================================================== */}

        {!cargando &&
          listadoSanciones.length ===
            0 && (
            <section className="san-v2-section">

              <div
                className="san-v2-section-content"
                style={{
                  padding:
                    "35px 20px",

                  textAlign:
                    "center",
                }}
              >

                <div
                  className="san-v2-stat-icon san-v2-stat-icon-confirm"
                  style={{
                    margin:
                      "0 auto 10px",
                  }}
                >
                  ✓
                </div>

                <strong
                  style={{
                    display:
                      "block",

                    color:
                      "#344054",

                    fontSize:
                      "13px",
                  }}
                >
                  Sin recursos pendientes
                </strong>

                <span
                  style={{
                    display:
                      "block",

                    marginTop:
                      "4px",

                    color:
                      "#98a2b3",

                    fontSize:
                      "11px",
                  }}
                >
                  No existen sanciones
                  reclamadas pendientes de
                  resolución.
                </span>

              </div>

            </section>
          )}

        {/* ==================================================== */}
        {/* CATEGORIAS */}
        {/* ==================================================== */}

        {!cargando &&
          Object.entries(
            categorias
          ).map(
            ([
              estado,
              sanciones,
            ]) => (
              <section
                key={estado}
                className="san-v2-section"
              >

                {/* ========================================== */}
                {/* HEADER */}
                {/* ========================================== */}

                <div className="san-v2-section-header">

                  <div className="san-v2-section-title-group">

                    <div className="san-v2-indicator san-v2-indicator-purple" />

                    <div>

                      <h2>
                        {estado}
                      </h2>

                      <p>
                        {
                          sanciones.length
                        }{" "}
                        {sanciones.length ===
                        1
                          ? "recurso pendiente"
                          : "recursos pendientes"}{" "}
                        de resolución.
                      </p>

                    </div>

                  </div>

                  <span className="san-v2-section-badge">
                    {
                      sanciones.length
                    }
                  </span>

                </div>

                {/* ========================================== */}
                {/* LISTADO */}
                {/* ========================================== */}

                <div className="san-v2-section-content">

                  {sanciones.map(
                    (
                      sancion,
                      index
                    ) => {
                      const ubicacion =
                        obtenerUbicacion(
                          sancion
                        );

                      const promocion =
                        obtenerPromocion(
                          sancion
                        );

                      return (
                        <div
                          key={
                            sancion?.id ||
                            index
                          }
                          className="san-v2-selected-person"
                          style={{
                            margin:
                              "6px",

                            background:
                              "#ffffff",
                          }}
                        >

                          {/* ================================= */}
                          {/* NUMERO */}
                          {/* ================================= */}

                          <div className="san-v2-avatar">
                            {index + 1}
                          </div>

                          {/* ================================= */}
                          {/* DATOS */}
                          {/* ================================= */}

                          <div className="san-v2-selected-info">

                            <span>
                              RECURSO · SANCIÓN #
                              {sancion?.id ||
                                "-"}
                            </span>

                            <strong>
                              {nombreCompleto(
                                sancion
                              ) ||
                                `DNI ${sancion?.cadeteDni}`}
                            </strong>

                            <small>
                              DNI{" "}
                              {
                                sancion?.cadeteDni
                              }

                              {" · "}

                              Fecha:{" "}
                              {formatearFecha(
                                sancion?.fechaFaltaCometida
                              )}

                              {sancion?.cadeteSede
                                ? ` · Sede: ${sancion.cadeteSede}`
                                : ""}

                              {ubicacion
                                ? ` · ${ubicacion}`
                                : ""}

                              {promocion
                                ? ` · Promoción: ${promocion}`
                                : ""}

                              {sancion?.cantidad
                                ? ` · Cantidad: ${sancion.cantidad}`
                                : ""}
                            </small>

                          </div>

                          {/* ================================= */}
                          {/* RESOLVER */}
                          {/* ================================= */}

                          <button
                            type="button"
                            className="san-v2-btn-primary"
                            onClick={() =>
                              manejoQueVeo(
                                sancion
                              )
                            }
                          >
                            Resolver
                          </button>

                        </div>
                      );
                    }
                  )}

                </div>

              </section>
            )
          )}

      </div>
    </>
  );
};

export default ObtieneSancionesRecursadas;